module.exports = __webpack_public_path__ + "static/media/danger.36503000.mp3";